import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_SeatSetting/Load',
      params,
    });
  },
  SelectData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_SeatSetting/SelectData',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_SeatSetting/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_SeatSetting/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_SeatSetting/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_SeatSetting/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
